import React, { forwardRef, useRef, FC, SyntheticEvent, FocusEventHandler } from 'react';
import { time } from 'uniqid';

export type ToggleProps = {
  id?: string;
  name: string;
  ariaLabel?: string;
  disabled?: boolean;
  checked?: boolean;
  onChange: (e: SyntheticEvent) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  className?: string;
  children?: React.ReactNode;
};
const voidFunc = () => true;
export const Toggle: FC<ToggleProps> = forwardRef<HTMLInputElement, ToggleProps>(
  (
    {
      checked = false,
      id = time('toggle-id-'),
      ariaLabel,
      disabled = false,
      onChange,
      onBlur = () => true,
      onFocus = () => true,
      className = '',
      name,
      children
    },
    ref
  ) => {
    const checkRef = useRef(null);
    const refDom = ref || checkRef;

    return (
      <div className={`${className} d-flex flex-row`}>
        <span className={`toggle-switch ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}>
          <input
            name={name}
            ref={refDom}
            id={id}
            data-testid={id}
            checked={checked}
            aria-label={ariaLabel}
            disabled={disabled}
            type="checkbox"
            onBlur={onBlur}
            onFocus={onFocus}
            onClick={onChange}
            onChange={voidFunc}
          />
        </span>
        <label htmlFor={id} className="toggle-label my-auto">
          {children}
        </label>
      </div>
    );
  }
);

Toggle.displayName = 'Toggle';
export default Toggle;
